import type { User } from "~/types/user";

export function isGuestUser(user: User | null | undefined) {
  if (!user) {
    return true;
  }
  const email = user.basicInfo?.email;
  if (!email) {
    return true;
  }
  if (email.startsWith("facebook-user")) {
    return false;
  }
  return email.endsWith("@fake.email");
}

/** A trial unlocks what a paid membership does; a paused membership unlocks nothing. */
export function isMember(user: User | null | undefined): boolean {
  const status = user?.membership?.status;
  return (
    status === "active_member" ||
    status === "active_member_no_renewal" ||
    status === "trial_member" ||
    status === "trial_member_no_renewal"
  );
}

/**
 * True when the user has a complete saved shipping address (street/city/state/zip). Users with one
 * skip the checkout shipping-info step, so this is needed to read the funnel correctly.
 */
export function hasCompleteShippingAddress(user: User | null | undefined): boolean {
  const s = user?.addresses?.shipping;
  return Boolean(s && s.street && s.city && s.state && s.zip);
}
